import { render, staticRenderFns } from "./InvitationButton.vue?vue&type=template&id=de28a85e&scoped=true"
import script from "./InvitationButton.vue?vue&type=script&lang=js"
export * from "./InvitationButton.vue?vue&type=script&lang=js"
import style0 from "./InvitationButton.vue?vue&type=style&index=0&id=de28a85e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de28a85e",
  null
  
)

export default component.exports